export default __webpack_public_path__ + "static/media/meet-the-toys-mobile.49bfc0f4.png";